import { cn } from "@/lib/utils";

const FormLabel = ({
  children,
  className,
  isCheckbox = false,
}: {
  children: React.ReactNode;
  className?: string;
  isCheckbox?: boolean;
}) => (
  <label
    className={cn(
      "px-[6px] bg-white text-[12px] text-g-400 flex items-center line-clamp-1",
      className,
      isCheckbox ? "" : "absolute top-[-9px] left-[14px] z-1"
    )}
  >
    {children}
  </label>
);

export default FormLabel;
